"use client";

import React from "react";

export const SUPErrorFallback = ({ children }: { children?: React.ReactNode }) => (
	<div className="@container min-h-screen bg-white max-w-7xl mx-auto relative">
		<div className="flex items-center justify-center h-96">
			<div className="text-center p-6">
				<div className="text-gray-800 font-semibold mb-2">Property Details Error</div>
				<p className="text-gray-600 text-sm">Unable to load property details. Please try refreshing the page.</p>
			</div>
		</div>
		{children}
	</div>
);
